import Vue from 'vue';

Vue.directive('clo-lazy-trigger', {
	bind: (el, binding) => {
		const io = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.intersectionRatio > 0) {
					binding.value(binding.arg);
				}
			});
		}, { threshold: [0, 0.5, 1] });
		io.observe(el);
	},
});
